<template>
  <div class="home-nvm">
    <ul>
      <li @click="$router.push({path: '/meetings'})">
        <img src="../../assets/home/home-nav1.png" alt="">
        <span>会议</span>
      </li>
      <li @click="$router.push({path: '/case'})">
        <img src="../../assets/home/home-nav2.png" alt="">
        <span>学习病例</span>
      </li>
      <li>
        <img src="../../assets/home/home-nav3.png" alt="">
        <span>待开发</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HomeNav"
}
</script>

<style lang="scss" scoped>
.home-nvm {
  ul {
    display: flex;
    justify-content: space-around;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 120px;
        height: 120px;
      }
      span {
        font-size: 24px;
        color: #333333;
      }
    }
  }
}
</style>
